export default "__VITE_ASSET__DgTaFv86__"